import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyDescriptionRichTextEditor = loadable(() => import('./DescriptionRichTextEditor'), 'DescriptionRichTextEditor');
